export default __webpack_public_path__ + "static/part3_4-f54ec9ac5612078899fac6494d87b6f6.png";